import React from 'react';
import { observer } from 'mobx-react';
import { Selected } from 'libs/forms/styles';

export const ProjectTypeItem = observer(({ selected, fieldStore }) => (
  <Selected>{selected[fieldStore.conf.labelKey]}</Selected>
));
